import axios from 'axios';
import BaseAPI from './base/base-api';

class AccountAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'InvoiceBotsAPI';
    controllerName = 'account';

}

export default new AccountAPI();